// Canva-style crop-box resizing. The element box IS the crop window; the image
// is centered inside it with an `offset`. Dragging a side/corner handle resizes
// the box while compensating the offset so the image stays visually fixed in
// canvas space (non-destructive crop). Pure geometry — no DOM, fully testable.
//
// Re-derivation (X axis): image absolute left = x + (width - imgW)/2 + offsetX.
// Holding that constant while the box's horizontal extent changes (via E or W)
// shifts the box center by ±delta/2, so offsetX must shift by -delta/2.

const MIN_SIZE = 20;

// box: { x, y, width, height, offsetX, offsetY }
// handle: one of n, s, e, w, ne, nw, se, sw
// dx, dy: drag delta in canvas (unzoomed) coordinates
export function cropResize(box, handle, dx, dy) {
  let { x, y, width, height, offsetX = 0, offsetY = 0 } = box;
  const h = String(handle || '');

  if (h.includes('e')) {
    const d = Math.max(dx, MIN_SIZE - width); // keep width >= MIN
    width += d;
    offsetX -= d / 2;
  }
  if (h.includes('w')) {
    const d = Math.min(dx, width - MIN_SIZE); // keep width >= MIN
    x += d;
    width -= d;
    offsetX -= d / 2;
  }
  if (h.includes('s')) {
    const d = Math.max(dy, MIN_SIZE - height);
    height += d;
    offsetY -= d / 2;
  }
  if (h.includes('n')) {
    const d = Math.min(dy, height - MIN_SIZE);
    y += d;
    height -= d;
    offsetY -= d / 2;
  }

  return { x, y, width, height, offsetX, offsetY };
}

export const CROP_MIN_SIZE = MIN_SIZE;
